import Vue from 'vue'
export default {
    template: '<div></div>',
    props: {
        disabled: Boolean,
        readonly: Boolean
    },
    created(){
        this.resolveWidgetOptions()
        this.$_nativeTemplates = []
        this.$on('kendowidgetready', this.ready)
    },
    beforeDestroy() {
        if(this.kendoWidget() && this.kendoWidget().destroy){
            this.kendoWidget().destroy()
            if(this.$_nativeTemplates.length){
                for (var i = 0; i < this.$_nativeTemplates.length; i++) {
                    this.$_nativeTemplates[i].$destroy()
                }
            }
        }
    },
    mounted(){
        for (var key in this.$options.propsData) {
            var that = this

            if(key.toLowerCase().indexOf('template') !== -1){
                var isFunction = this.widgetOptions[key] instanceof Function

                if(isFunction){
                    this.widgetOptions[key] = this.transformTemplate(key)
                }
            }

            if(key === 'value') {
                that.$watch(key, function(newValue){
                    that.changeValue(newValue)
                })
            } else if (key === 'disabled') {
                that.$watch(key, function(newValue){
                    that.makeDisabled(newValue)
                })
            } else if (key === 'readonly') {
                that.$watch(key, function(newValue){
                    that.makeReadonly(newValue)
                })
            } else {
                that.$watch(key, function(newValue, oldValue){
                    // Vue always dispatches a change when inline complex objects are bound
                    // https://github.com/telerik/kendo-ui-core/issues/3952
                    if (JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
                        that.updateWidget()
                    }
                })
            }
        }
    },
    methods:{
        updateWidget() {
            var that = this

            that.resolveWidgetOptions()

            if(that._resolveChildren){
                that._resolveChildren()
            }

            if(that.kendoWidget().setOptions){
                that.kendoWidget().setOptions(that.widgetOptions)
            }
        },
        transformTemplate: function (key, val) {
            var that = this
            var object
            var templateDefinition = val || that.$options.propsData[key]
            try{
                object = templateDefinition.call(that, {})
            }
            catch (e){
                return templateDefinition
            }

            if(!object.template){
                return templateDefinition
            }

            return function(){
                object = templateDefinition.apply(this, arguments)
                var vueObject = new Vue(object.template)
                vueObject.$data.templateArgs = object.templateArgs

                var kendoguid = 'kendo' + kendo.guid()
               
                that.$nextTick(function(){
                    vueObject.$mount('#' + kendoguid)
                    that.$_nativeTemplates.push(vueObject)
                })

                return '<div id="' + kendoguid + '"></div>'
            }
        },
        resolveChildren(prop, name) {
            if(!this.widgetOptions[prop] && this.$slots.default){
                var items = []
                for(const childSlot of this.$slots.default){
                    if((childSlot.tag && childSlot.tag.indexOf(name) !== -1)) {
                        var itemOptions = this.parseOptions(childSlot.componentInstance)
                        items.push(itemOptions)
                        this.handleWatcher(childSlot.componentInstance)
                    }
                }

                if(items.length){
                    this.widgetOptions[prop] = items
                }
            }
        },
        handleWatcher(childInstance) {
            var that = this

            if(!childInstance._isWatchAttached){
                childInstance.$watch('$props', () => {
                    if(that.updateWidget){
                        that.updateWidget()
                    } else if (that._resolveInnerChildren) {
                        that._resolveInnerChildren()
                    }
                }, { deep: true })

                childInstance._isWatchAttached = true
            }
        },
        makeDisabled(toDisable){
            if(this.kendoWidget().enable){
                this.kendoWidget().enable(!toDisable)
            }
        },
        makeReadonly(value){
            if(this.kendoWidget().readonly){
                this.kendoWidget().readonly(value)
            }
        },
        changeValue(newValue){
            if(this.kendoWidget().value){
                this.kendoWidget().value(newValue)
            }
        },
        resolveWidgetOptions(){
            this.widgetOptions = this.parseOptions()
        },
        parseOptions(component){
            var that = component || this
            var options = {}
            for (let key in that.$options.propsData) {
                var propOptions = that.$options.props[key]
                var val = that.$options.propsData[key]

                var compositeProps = propOptions.kComposite

                if(!compositeProps) {
                    if(key.toLowerCase().indexOf('template') !== -1
                        && (val instanceof Function)){
                        options[key] = this.transformTemplate(key, val)
                    } else{
                        options[key] = val
                    }
                }else{
                    this.addCompositeProperty(options, compositeProps.split('.'), that.$props[key])
                }
            }

            Object.keys(that.$props).forEach((event) => {
                if(that.$listeners && that.$listeners[event.toLowerCase()]){
                    var kendoIndex = event.lastIndexOf('kendo')
                    var kendoEvent
                    if(kendoIndex !== -1){
                        kendoEvent = event.replace('kendo','').toLowerCase()
                    }

                    options[kendoEvent || event] = that.$listeners[event.toLowerCase()]
                }
            })

            return options
        },
        addCompositeProperty (obj, keys, val) {
            const lastKey = keys.pop()
            const lastObj = keys.reduce(function (obj, key) {
                obj[key] = (typeof obj[key] === 'object') ? obj[key] || {} : {}
                return obj[key]
            }, obj)

            if(lastKey.toLowerCase().indexOf('template') !== -1
              && (val instanceof Function)){
                lastObj[lastKey] = this.transformTemplate(lastKey, val)
            } else{
                lastObj[lastKey] = val
            }
        },
        ready(){
            if(this.$options.propsData.disabled){
                this.makeDisabled(true)
            }

            if(this.$options.propsData.readonly){
                this.makeReadonly(true)
            }
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-base-components-vue-wrapper/src/kendo-base-component/index.js